<template>
  <!-- Il dialog viene mostrato solo se è già presente una diaria associata alla categoria di costo attualmente attiva -->
  <wg-modal
    v-if="showReplaceDialog"
    @closeModal="$emit('done')"
  >
    <div class="wg-row" style="justify-content:center;" slot="body">
      <div class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 
            'Replace daily pay for the currently selected cost category?', 
            'Sostituire la diaria della categoria di costo attualmente selezionata?') }}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row" style="align-items:center;justify-content:center;">
        <input
          type="button"
          class="small com-anm22-button-green"
          :value="$anm22.strLang(lang, 'Yes', 'Sì')"
          @click="setDiary"
        >
        <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
        <input
          type="button"
          class="small com-anm22-button-red"
          :value="$anm22.strLang(lang, 'No', 'No')"
          @click="$anm22.eventBus.$emit('wg-modal-close')"
        >
      </div>
    </div>
  </wg-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    projectId: [Number, String]
  }, 
  data() {
    return {
      showReplaceDialog: false
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    project() {
      return this.$store.getters['projects/get'](this.projectId);
    },
    pricing() {
      return this.$store.getters['pricings/getByProject'](this.project.idWorldProject);
    },
    workCost() {
      return this.$store.getters['workCosts/get'](this.pricing.costCategory);
    }
  },
  methods: {
    setDiary() {
      this.$http
        .post('link/setDiaryFromPlace', {
          projectId: this.project.idWorldProject
        })
        .then(response => {
          // Aggiorno categoria di costo e chiudo
          this.$store.dispatch("workCosts/update", {
            vlf: this.$vlf("workCosts"),
            objs: response.data.workCosts
          })
          .then(() => {
            this.$emit('done');
          })
        })
        .catch(e => console.log(e));
    }
  },
  created() {
    //Devo  assicurarmi di avere il pricing e la categoria di costo per effettuare i controlli
    this.$http
      .get("link/pricing?idProject=" + this.projectId)
      .then(response => {
        Promise.all([
          this.$store.dispatch("pricings/update", {
            vlf: this.$vlf("pricings"),
            objs: [response.data.pricing],
            cleanFilters: [p => p.project === this.project.idWorldProject]
          }),
          this.$store.dispatch("workCosts/update", {
            vlf: this.$vlf("workCosts"),
            objs: response.data.workCosts
          })
        ]).then(() => {
          const workPlaceAssoc = this.$store.getters['workPlaceAssocs/get'](this.project.place+'-474');
          //Controllo diaria per la categoria di costo attualmente selezionata
          if(this.workCost && workPlaceAssoc) {
            if(this.workCost.dailyPay && workPlaceAssoc.diary) {
              //Mostro il dialog per la conferma
              this.showReplaceDialog = true;
            } else {
              this.setDiary();
            }
          } else {
            // Se non ho un pricing o non è settata la categoria di costo allora non faccio nulla
            this.$emit('done');
          }
        });
      });
  }
}
</script>

<style lang="scss" scoped>

</style>
